import { Component, OnInit, ViewChild } from '@angular/core';
import { SelectIndexCIF } from '../../../shared/viewmodels/UtilityObj';
import { Store } from '@ngrx/store';
import { CoreSearchDataState as AppState, getRegSearchState } from '../../../store/reducers/reducers';
import { DxListModule, DxListComponent } from "devextreme-angular";

@Component({
  selector: 'app-select-index',
  templateUrl: './select-index.component.html',
  styleUrls: ['./select-index.component.css']
})
export class SelectIndexComponent implements OnInit {

  //@ViewChild(DxListComponent, { }) list: DxListComponent;
  // Prior to Angular 8
   //@ViewChild(DxListComponent) list: DxListComponent;

  public utilityobj: SelectIndexCIF;
  message: any;
  helpText: string;
  indexId: number;
  header: string;

  listItems = [{
      id: 1,
      name: 'Writs 1911-1966',
      help: 'Writs for the years between 1911 and 1966.  Scroll through images to find writ.',
      header: 'Year'
    },
    {
      id: 2,
      name: 'Attachments 1967 - 2006',
      help: 'Enter Writs of Attachment # (1 - 7217).  Writs recorded after 2006 are in Deed Books.',
      header: 'Writ of Attachment Number'
    },
    {
      id: 3,
      name: 'Old Age Assistance Liens Index 1942-1950',
      help: 'Old Age Assistance Liens Index 1942-1950'
    },
    //{
    //  id: 4,
    //  name: 'Old Age Assistance Liens Index 1949-1988',
    //  help: ''
    //},
    {
      id: 4,
      name: 'Old Age Assistance Liens',
      help: 'Old Age Assistance Liens'
    },
    {
      id: 5,
      name: 'Grantor 1840-1860',
      help: 'Grantor Index list from 1840-1860'
    },
    {
      id: 6,
      name: 'Grantee 1840-1860',
      help: 'Grantee Index List from 1840 to 1860'
    },
    {
      id: 7,
      name: 'Grantor 1861-1885',
      help: 'Grantor Index list from 1861 to 1885'
    },
    {
      id: 8,
      name: 'Grantee 1861-1885',
      help: 'Grantee Index List from 1861 to 1885'
    },
    {
      id: 9,
      name: 'Grantor 1886-1909',
      help: 'Grantor Index list from 1886 to 1909'
    },
    {
      id: 10,
      name: 'Grantee 1886-1909',
      help: 'Grantee Index List from 1886 to 1909'
    },
    {
      id: 11,
      name: 'Grantor 1909-1926',
      help: 'Grantor Index list from 1909 to 1926'
    },
    {
      id: 12,
      name: 'Grantee 1909-1926',
      help: 'Grantee Index List from 1909 to 1926'
    },
    {
      id: 13,
      name: 'Grantor 1926-1938',
      help: 'Grantor Index list from 1926 to 1938'
    },
    {
      id: 14,
      name: 'Grantee 1926-1938',
      help: 'Grantee Index List from 1926 to 1938'
    },
    {
      id: 15,
      name: 'Grantor 1938-1947',
      help: 'To find town tax liens, payments and redemptions for property in this index, examine the Grantor index entries for the Town/Municipality in which the property lies and scan down the reverse party/owner list to find reference to instruments affecting property.'
    },
    {
      id: 16,
      name: 'Grantee 1938-1947',
      help: 'Grantee Index List from 1938 to 1947'
    },
    {
      id: 17,
      name: 'Grantor 1948-1951',
      help: 'Grantor Index list from 1948 to 1951'
    },
    {
      id: 18,
      name: 'Grantee 1948-1951',
      help: 'Grantee Index List from 1948 to 1951'
    },
    {
      id: 19,
      name: 'Grantor 1952-1961',
      help: 'Grantor Index list from 1952 to 1961'
    },
    {
      id: 20,
      name: 'Grantee 1952-1961',
      help: 'Grantee Index List from 1952 to 1961'
    }

  ];



  constructor(private store: Store<AppState>) {
    this.utilityobj = new SelectIndexCIF();
    this.store.select(getRegSearchState).subscribe(data => this.message = data);
    //console.log(this.message.role[0]);
    //if (this.message.roletype.length != 0) {
    //  this.utilityobj.indexId = this.message.selectIndex[0].indexID;
      //console.log(this.message.role[0]);
    //} else {
    //this.utilityobj.indexId = 1;
    //this.indexId = 1;
    this.utilityobj.indexId = 5;
    this.indexId = 5;
    //}
  }

  ngOnInit() {

    //this.list.instance.selectItem(3);
  }



  ItemClick(e) {

    this.utilityobj.indexId = e.itemData.id;
    this.indexId = e.itemData.id;
    this.helpText = e.itemData.help;
    this.header = e.itemData.header;
    //console.log('index ' + e.itemdata.id);

  }  
}
